export const FOREIGN_TRADE_BY_COUNTRIES = 'foreignTradeByCountries';

export const FOREIGN_TRADE_BY_COUNTRIES_ACTIONS_NAME = {
  searchCountryAggregated: `${FOREIGN_TRADE_BY_COUNTRIES}/searchCountryAggregated`,
} as const;

export const FOREIGN_TRADE_BY_COUNTRIES_MUTATIONS_NAME = {
  setCountryAggregated: `${FOREIGN_TRADE_BY_COUNTRIES}/setCountryAggregated`,
} as const;

export const FOREIGN_TRADE_BY_COUNTRIES_GETTERS_NAME = {
  getCountryAggregated: `${FOREIGN_TRADE_BY_COUNTRIES}/getCountryAggregated`,
} as const;
